export const themeTabs = {
  tablist: {
    styles: { underline: 'border-b-0 pl-8' },
    tabitem: {
      styles: {
        underline: { active: { on: 'border-b-2 border-blue-600 text-blue-600 focus:ring-0 px-8', off: 'border-blue-600 focus:ring-0 px-8' } },
      },
    },
  },
};

export const themTooltip = {
  target: 'w-full overflow-hidden text-ellipsis whitespace-nowrap',
  base: 'bg-blue-600 ',
  style: {
    dark: 'bg-gray-800 bg-opacity-80 text-white px-2 py-1 !left-14 !top-8 rounded',
  },
};

export const themModal = {
  content: {
    base: 'relative w-full p-4 md:h-auto',
  },
};